import { useFetchedOnboardingProgress } from '../../onboarding/hooks/useFetchedOnboardingProgress';
import { ONBOARDING_STATE_IN_PROGRESS, ONBOARDING_STATE_NOT_STARTED } from '../../user/userApi';
import { SplashScreen } from '../../commons/SplashScreen';
import { OnboardingWizard } from '../../onboarding/containers/OnboardingWizard';
import { SideBar } from '../../navigation/SideBar';
import AppRouter from '../../router/AppRouter';
import React from 'react';
import { useFetchedBillingCustomer } from '../../billing/hooks/useFetchedBillingCustomer';
import { InactiveSubscriptionBilling } from '../../billing/containers/InactiveSubscriptionBilling';
import { SanityChecker } from '../../meta/components/SanityChecker';
import { isSubscriptionPaused } from '../../billing/utils';

export const AuthenticatedAppRoot = () => {
  const {
    query: { data: onboardingProgress, status: onboardingProgressStatus },
    queryStatusComponent: onboardingProgressStatusComponent,
  } = useFetchedOnboardingProgress();

  const {
    query: { data: customer, status: customerStatus },
    queryStatusComponent: customerStatusComponent,
  } = useFetchedBillingCustomer();

  const isOnboardingRunning =
    onboardingProgress &&
    (onboardingProgress.state === ONBOARDING_STATE_NOT_STARTED ||
      onboardingProgress.state === ONBOARDING_STATE_IN_PROGRESS);

  const now = new Date();
  return (
    <>
      {!onboardingProgress ? (
        <SplashScreen queryStatus={onboardingProgressStatus}>
          {onboardingProgressStatusComponent}
        </SplashScreen>
      ) : !customer ? (
        <SplashScreen queryStatus={customerStatus}>{customerStatusComponent}</SplashScreen>
      ) : !customer.activeSubscription || isSubscriptionPaused(customer.activeSubscription, now) ? (
        <InactiveSubscriptionBilling customer={customer} />
      ) : isOnboardingRunning ? (
        <OnboardingWizard onboardingProgress={onboardingProgress} />
      ) : (
        <>
          <SideBar />
          <AppRouter />
        </>
      )}
      <SanityChecker />
    </>
  );
};
